<template>
  <div>
    <Homeicon />
    <UserName />
    <Backicon v-if="$route.name !== 'Home'"/>
  </div>
</template>

<script>
import Homeicon from "@/components/Homeicon";
import UserName from "@/components/UserName";
import Backicon from "@/components/Backicon";
export default {
  name: "Header",
  components: {
    Homeicon,
    UserName,
    Backicon,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue